import React from 'react'
import CommWhatsAppCompose from './CommWhatsAppCompose'

// Created By Cursor
const CommComposeExams = (props) => (
  <CommWhatsAppCompose {...props} titleHint="Exams & Results" />
)

export default CommComposeExams
